<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		quickExit?: boolean;
	}>(),
	{
		quickExit: false
	}
);

const emit = defineEmits<{
	(e: 'close'): void;
}>();

function onBackdropClick() {
	if (!props.quickExit) return;
	emit('close');
}
</script>

<template>
	<!-- Background -->
	<div class="modal-backdrop" @click.self="onBackdropClick">
		<!-- Modal -->
		<div class="base-modal fira">
			<!-- Header close button -->
			<button class="icon-button absolute" @click="emit('close')">
				<span class="material-symbols-outlined light">close_small</span>
			</button>

			<!-- Default content slot -->
			<slot />
		</div>
	</div>
</template>

<style scoped>
/* --- Modal Backdrop --- */
.modal-backdrop {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
}

/* --- Modal Container --- */
.base-modal {
	width: max-content;
	height: max-content;
	min-width: 25vw;
	max-height: 70vh;
	overflow-y: auto;
	background: #fff;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	user-select: none;
	position: relative;
	padding: 10px 15px;
}

.base-modal__content {
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 15px;
}

/* --- Close Button --- */
.icon-button.absolute {
	position: absolute;
	top: 8px;
	right: 8px;
}
</style>
